import { __rest } from './../../external/tslib/tslib.es6.js';
import React, { useEffect } from 'react';
import { SuccessFill } from '@olist/design-system-icons';
import { useSelect, unselectOption, selectOption, registerOption } from './SelectContext.js';
import { Mark, StyledDropdownItem, OptionText } from './styles.js';
import Checkbox from '../Checkbox/Checkbox.js';

function OptionContent({ option, badge, disabled, id, }) {
    const [{ multi, searchedTerm, onSelect, onClose, selectedOptions }, dispatch,] = useSelect();
    const handleSelect = () => {
        if (option === null || option === void 0 ? void 0 : option.selected) {
            if (selectedOptions) {
                onSelect(selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.filter((opt) => opt.value !== option.value));
            }
            unselectOption(dispatch, option);
            if (!multi) {
                onClose();
            }
            return;
        }
        selectOption(dispatch, option);
        onSelect(multi
            ? [...(selectedOptions || []), Object.assign(Object.assign({}, option), { selected: true })]
            : [Object.assign(Object.assign({}, option), { selected: true })]);
        if (!multi) {
            onClose();
        }
    };
    const splitReg = new RegExp(`(${searchedTerm})`, 'gi');
    const highlightedText = option.text
        .split(splitReg)
        .filter(Boolean)
        .map((text, index) => {
        if (text.toLowerCase() === (searchedTerm === null || searchedTerm === void 0 ? void 0 : searchedTerm.toLowerCase())) {
            return React.createElement(Mark, { key: `${text}${index}` }, text);
        }
        return text;
    });
    return (React.createElement(StyledDropdownItem, { id: id, disabled: disabled, forwardedAs: multi ? 'span' : 'button', onClick: multi ? undefined : handleSelect, tabIndex: multi ? -1 : undefined, "aria-selected": option === null || option === void 0 ? void 0 : option.selected, role: "option", badge: badge
            ? { text: badge.text, variation: badge.variation || 'info' }
            : undefined, backgroundColor: !multi && (option === null || option === void 0 ? void 0 : option.selected) ? 'primary.softer' : undefined },
        multi && (React.createElement(Checkbox, { checked: option === null || option === void 0 ? void 0 : option.selected, onChange: handleSelect, label: highlightedText })),
        !multi && highlightedText && (React.createElement(OptionText, null,
            React.createElement("span", null, highlightedText),
            (option === null || option === void 0 ? void 0 : option.selected) && React.createElement(SuccessFill, null)))));
}
function DesktopOption(_a) {
    var { children, value, badge, disabled, id, selected = false } = _a, props = __rest(_a, ["children", "value", "badge", "disabled", "id", "selected"]);
    const [{ options, isSearched, filteredOptions, previousSelectedOptions }] = useSelect();
    const findOption = (opt) => opt.value === value &&
        !(previousSelectedOptions === null || previousSelectedOptions === void 0 ? void 0 : previousSelectedOptions.some((prevOpt) => prevOpt.value === opt.value));
    const option = isSearched
        ? filteredOptions.find(findOption)
        : options.find(findOption);
    if (!option) {
        return null;
    }
    return (React.createElement(OptionContent, Object.assign({}, props, { option: option, badge: badge, disabled: disabled, id: option.id })));
}
const SELECT_OPTION_ID_PREFIX = 'olist-select-option-';
function MobileOption({ children, value, selected = false, disabled, id, }) {
    const [, dispatch] = useSelect();
    const optionId = id || `${SELECT_OPTION_ID_PREFIX}${value}`;
    useEffect(() => {
        registerOption(dispatch, {
            value,
            text: children,
            selected,
            id: optionId,
        });
    }, []);
    return (React.createElement("option", { value: value, disabled: disabled, id: optionId }, children));
}
function SelectOption(_a) {
    var props = __rest(_a, []);
    const [{ isMobile }] = useSelect();
    return isMobile ? React.createElement(MobileOption, Object.assign({}, props)) : React.createElement(DesktopOption, Object.assign({}, props));
}

export { DesktopOption, MobileOption, OptionContent, SelectOption };
